module.exports = __webpack_public_path__ + "img/inaya.81a2cfc3.png";